import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../../../../utils/apiClient';
import { applyLanguage } from '../../../../i18n';
import Wadsworth from '../../role-hac/wadsworth/wadsworth';
import SettingsPage from './settings-page';
import PasswordSettingsSection from './password-settings-section';
import LanguageSettingsSection from './language-settings-section';

const HacSettingsContent = () => {
  const { t } = useTranslation();
  const token = sessionStorage.getItem('token');
  const [language, setLanguage] = useState('');
  const [country, setCountry] = useState('');
  const [languages, setLanguages] = useState([]);
  const [feedback, setFeedback] = useState({ open: false, severity: 'success', message: '' });

  const showFeedback = (severity, message) => setFeedback({ open: true, severity, message });

  useEffect(() => {
    if (!token) return;
    apiClient.get('/hac/basic-info')
      .then(({ data }) => {
        setLanguage(data.preferred_language || data.preferredLanguage || '');
        setCountry(data.area_code || '');
      })
      .catch(() => showFeedback('error', t('common-internal-server-error')));
  }, [t, token]);

  useEffect(() => {
    if (!country) return;
    apiClient.get(`/hac/languages?area_code=${country}`)
      .then(({ data }) => setLanguages(data.flatMap(({ language: codes }) => (
        codes.map((code) => ({ code, name: t(`languages-${code}`) }))
      ))))
      .catch(() => showFeedback('error', t('common-internal-server-error')));
  }, [country, t]);

  const saveLanguage = async () => {
    try {
      await apiClient.patch('/hac/personal-settings', { language });
      await applyLanguage(language);
      showFeedback('success', t('language-settings-save-success'));
    } catch {
      showFeedback('error', t('common-internal-server-error'));
    }
  };

  return (
    <SettingsPage
      allowed={Boolean(token)}
      beforeContent={<Wadsworth />}
      feedback={feedback}
      onCloseFeedback={() => setFeedback((current) => ({ ...current, open: false }))}
    >
      <LanguageSettingsSection
        languages={languages}
        selectedLanguage={language}
        onLanguageChange={setLanguage}
        onSave={saveLanguage}
      />
      <PasswordSettingsSection />
    </SettingsPage>
  );
};

export default HacSettingsContent;
